import Idents from "../components/Idents";

const IdentsScreen = () => {
  return <Idents />;
};
export default IdentsScreen;
